import { render, staticRenderFns } from "./GoogleSignInButton.vue?vue&type=template&id=4941bfbf&scoped=true&"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=js&"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSignInButton.vue?vue&type=style&index=0&id=4941bfbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4941bfbf",
  null
  
)

export default component.exports